import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetCatalog, ResetArtistCatalogStore } from '../action-creators';
import { SetActiveArtist } from '@webapp/store/artist/action-creators';
import { SET_ACTIVE_ARTIST } from '../../artist/actions';

export const getArtistCatalogEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, SetActiveArtist>(SET_ACTIVE_ARTIST),
    concatMap((action) => [
      new ResetArtistCatalogStore(),
      new GetCatalog({
        type: 'COLLABORATOR',
        artistId: action.artist.id as string,
      }),
    ])
  );
